import * as React from "react";

export default class NotFoundPage extends React.Component {
  render() {
    return (
      <h1>404 Page</h1>
    );
  }
}